var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.fullScreenClass},[_c('vue-lottie-player',{staticClass:"m-auto",style:(_vm.style),attrs:{"loop":"","name":"spinner","path":"https://assets3.lottiefiles.com/packages/lf20_p6ywl1q2.json"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }